/**
 * Guid class, providing static property and method to generate new GUIDs and reference empty GUID.
 */
export abstract class Guid {

	/**
	 * Gets an empty GUID string.
	 * @returns String.
	 */ 
	static get empty(): string {
		return "00000000-0000-0000-0000-000000000000";
	}

	/**
	 * Creates and returns a new random GUID string.
	 * @returns String.
	 */
	static newGuid(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c == "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}